exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Thanks__wrapper___hKVeQ {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.Thanks__iconWrapper___3Wvtc {\n  margin: 220px 130px 30px 130px;\n}\n\n.Thanks__messageWrapper___28XRt {\n  margin-bottom: 30px;\n}\n\n.Thanks__successMessage___3W5AI {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.28;\n  color: #1e2535;\n}\n\n.Thanks__buttonWrapper___22gmw {\n  margin-bottom: 40px;\n}\n\n.Thanks__successButton___3ffD4 {\n  color: #1774f0;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 1.36;\n  cursor: pointer;\n}\n\n@media (min-width: 800px) {\n  .Thanks__iconWrapper___3Wvtc {\n    margin: 55px 80px 30px 80px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "Thanks__wrapper___hKVeQ",
	"iconWrapper": "Thanks__iconWrapper___3Wvtc",
	"messageWrapper": "Thanks__messageWrapper___28XRt",
	"successMessage": "Thanks__successMessage___3W5AI",
	"buttonWrapper": "Thanks__buttonWrapper___22gmw",
	"successButton": "Thanks__successButton___3ffD4"
};